import { PullDataSource, RequestStackItem } from './pull-source';
import { DataSourceOptions } from './types';
import { Application } from '../application/application';
import { Method, ResponseType, xhrPromise, XHRPromise, XHRResult } from '../xhr/xhr';
import { TimelineRange, TimeRange, CursorMillis } from '../timeline/timeline-common';

export class XHRDataSource extends PullDataSource {
	private dataPromise: XHRPromise;

	public constructor(options: DataSourceOptions, application: Application) {
		super(options, application);
	}

	/**
	 * Gets called just before the data is stored in source's storage
	 * Override if some data processing is requiered 
	 */
	protected processResponse(response: XHRResult): any {
		return response.data;
	}

	protected abortDataRequest(): void {
		if (this.dataPromise && this.dataPromise.canAbort()) {
			this.dataPromise.abort();
			this.dataPromise = null;
		}
	}

	protected doNextDataRequest(): Promise<{ request: RequestStackItem, data: any }> {
		//when there is no active data request running
		if (!this.dataPromise) {
			let request: RequestStackItem = this.popRequest();

			let method = request.types == null ? Method.get : Method.post;
			let query = this.getQuery(request.refresh, request.timeRange);
			let url = this.getOptions().url + (query ? '?' + query.substring(1) : '');

			let requestedTypes = this.getRequestedTypes(request);

			// console.log(`requesting data: ${method} ${url}${request.body != null ? `\nbody: ${request.body}` : ''}`);

			this.dataPromise = xhrPromise({
				url: url,
				method: method,
				digester: this.getApplication().getDigester(),
				responseType: ResponseType.json,
				data: requestedTypes ? { entity: requestedTypes.join(' '), mimeType: 'text/plain' } : undefined,
				noAbort: request.noAbort
			});

			return this.dataPromise.then(response => {
				return { request: request, data: this.processResponse(response) };
			}).finally(() => {
				this.dataPromise = null;
			});
		} else {
			return new Promise((_resolve, reject) => {
				reject("A remote data request is stil running. It should have been aborted first.");
			});
		}
	}


	private getQuery(refresh: boolean, requestedTimeLineRange: TimelineRange): string {

		let requestedTimeRange = requestedTimeLineRange.visible;
		let currentTimeRange = !refresh && this.getMeta().timeRange != null ? this.getMeta().timeRange.visible : null;

		if (currentTimeRange == null) {
			//the whole time range
			return `&rc=1${this.getTimeRangeQuery(0, requestedTimeRange)}` + (this.getOptions().query ? this.getOptions().query : '');

		} else {
			//the complementary time range
			let timeRangeComplement = requestedTimeRange.difference(currentTimeRange, this.getMeta().version);
			let temporalQuery = '&rc='
				+ (timeRangeComplement.rangesToAdd.length + (timeRangeComplement.rangeToUpdate != null ? 1 : 0));

			let i = 0;
			for (i = 0; i < timeRangeComplement.rangesToAdd.length; i++) {

				temporalQuery += this.getTimeRangeQuery(i, timeRangeComplement.rangesToAdd[i]);
			}
			if (timeRangeComplement.rangeToUpdate != null) {
				temporalQuery += this.getTimeRangeQuery(i, timeRangeComplement.rangeToUpdate);
			}
			return temporalQuery + (this.getOptions().query ? this.getOptions().query : '');
		}
	}

	private getTimeRangeQuery(i: number, timeRange: TimeRange): string {
		return `&s${i}=${new Date(timeRange.start).toISOString()
			}&e${i}=${new Date(timeRange.end).toISOString()
			}&r${i}=${timeRange.mspp
			}${timeRange.version != null ? `&v${i}=${timeRange.version
				}` : ''}`;
	}

}